export default __webpack_public_path__ + "static/media/new-image.6a9e7b8b.png";